/* perf 30.09 D-10: skrypt paska ATC (sticky) przeniesiony z inline snippets/new-atc.liquid do pliku z defer
   (23 KB HTML na każdej karcie produktu -> plik w pamięci przeglądarki między stronami). Logika bez zmian
   (poprawki B-04 z tego samego audytu w środku); jedyna wstawka Liquid (tryb pokazywania) czytana z data-show-mode.
   Start jak dotąd po DOMContentLoaded; strażnik chroni przed podwójnym startem, gdy snippet wyrenderuje się 2 razy. */
(function () {
  function initStickyAtc() {
    if (window.__svStickyAtcInit) return;
    window.__svStickyAtcInit = true;

    /* perf 30.09 B-04: pasek ATC bez odczytow ukladu przy przewijaniu i bez obserwatorow DOM na <body>.
       - widocznosc: wylacznie IntersectionObserver (glowny przycisk, stopka, naglowek); bez nasluchu scroll/resize
         i bez getBoundingClientRect/innerWidth (lab 30.09: callbacki IO z getBoundingClientRect = 58-75 ms wymuszonego ukladu);
       - klikniecie: jeden nasluch delegowany zamiast przypinania do przyciskow przez 2 MutationObservery
         (product-info.js podmienia zawartosc .sticky-atc przy zmianie wariantu, delegacja dziala bez ponownego przypinania);
       - obsluga progow ilosciowych Lumin tylko wtedy, gdy na karcie sa takie pola (.bs-form-check-input). */
    var atcElement = document.querySelector(".sticky-atc");
    if (!atcElement) return;

    var footerElement = document.querySelector(".footer__content-bottom");
    var headerElement = document.querySelector('sticky-header') ||
      document.querySelector('header') ||
      document.querySelector('.header') ||
      document.querySelector('[class*="header"]');
    var stickyAtcShowMode = atcElement.dataset.showMode || 'when_not_in_view';
    var desktopPosition = atcElement.dataset.desktopPosition;
    var mobilePosition = atcElement.dataset.mobilePosition;
    var mobileQuery = window.matchMedia('(max-width: 749px)');

    function getMainAtcTarget() {
        var buttons = document.querySelectorAll('[id^="ProductSubmitButton-"]');
        for (var i = 0; i < buttons.length; i++) {
            if (!buttons[i].closest('.sticky-atc')) {
                return buttons[i];
            }
        }
        return buttons[0] || null;
    }

    var targetElement = getMainAtcTarget();

    function findCurrentAtcButton() {
        var atcButtons = document.querySelectorAll('[id^="ProductSubmitButton-"]');

        if (atcButtons.length === 0) {
            return null;
        }

        if (atcButtons.length === 1) {
            return atcButtons[0];
        }

        for (var i = 0; i < atcButtons.length; i++) {
            var button = atcButtons[i];
            if (button.offsetParent !== null && !button.disabled && button.style.display !== 'none') {
                return button;
            }
        }

        return atcButtons[0];
    }

    function showStickyButtonLoading(clickedButton) {
        var originalText = clickedButton.querySelector('span').textContent;
        var originalSpinner = clickedButton.querySelector('.loading-spinner');
        var loadingSeq = (parseInt(clickedButton.dataset.stickyAtcLoadingSeq, 10) || 0) + 1;
        clickedButton.dataset.stickyAtcLoadingSeq = String(loadingSeq);

        clickedButton.dataset.originalText = originalText;
        clickedButton.dataset.originalSpinner = originalSpinner ? 'true' : 'false';

        clickedButton.classList.add('loading');
        clickedButton.disabled = true;

        var dotsContainer = document.createElement('div');
        dotsContainer.className = 'loading-dots';
        dotsContainer.innerHTML = '<span class="dot"></span><span class="dot"></span><span class="dot"></span>';

        var textSpan = clickedButton.querySelector('span');
        textSpan.style.transform = 'translateY(-100%)';
        textSpan.style.opacity = '0';

        setTimeout(function() {
            if (parseInt(clickedButton.dataset.stickyAtcLoadingSeq, 10) !== loadingSeq) return;
            textSpan.style.display = 'none';
            clickedButton.appendChild(dotsContainer);

            var dots = dotsContainer.querySelectorAll('.dot');
            dots.forEach(function(dot, index) {
                dot.style.animationDelay = (index * 0.2) + 's';
                dot.style.animation = 'dotAppear 0.6s ease-out forwards';

                setTimeout(function() {
                    if (parseInt(clickedButton.dataset.stickyAtcLoadingSeq, 10) !== loadingSeq) return;
                    dot.style.animation = 'dotWave 1.6s ease-in-out infinite';
                    dot.style.animationDelay = (index * 0.2) + 's';
                    dot.classList.add('wave-animating');
                }, 600 + (index * 200));
            });
        }, 300);

        if (originalSpinner) {
            originalSpinner.style.display = 'none';
        }
    }

    function hideStickyButtonLoading(clickedButton) {
        clickedButton.dataset.stickyAtcLoadingSeq = String((parseInt(clickedButton.dataset.stickyAtcLoadingSeq, 10) || 0) + 1);
        clickedButton.classList.remove('loading');
        clickedButton.disabled = false;

        var dotsContainer = clickedButton.querySelector('.loading-dots');
        if (dotsContainer) {
            dotsContainer.remove();
        }

        var textSpan = clickedButton.querySelector('span');
        textSpan.style.display = 'block';
        textSpan.style.transform = 'translateY(100%)';
        textSpan.style.opacity = '0';

        setTimeout(function() {
            textSpan.style.transition = 'all 0.4s ease-out';
            textSpan.style.transform = 'translateY(0)';
            textSpan.style.opacity = '1';
        }, 50);

        if (clickedButton.dataset.originalText) {
            textSpan.textContent = clickedButton.dataset.originalText;
        }

        var spinner = clickedButton.querySelector('.loading-spinner');
        if (spinner && clickedButton.dataset.originalSpinner === 'true') {
            spinner.style.display = 'block';
        }
    }

    function handleStickyAtcClick(e, clickedButton) {
        e.preventDefault();

        showStickyButtonLoading(clickedButton);

        /* perf 30.09 B-04: najpierw kropki ładowania na ekranie, klik w główny przycisk dopiero w następnym zadaniu
           (wzorzec Shopify „yield to main thread”). Syntetyczny click() w tym samym zadaniu uruchamiał drugi raz wszystkie
           globalne słuchacze kliknięć (gtag ×2, piksel Meta po zgodzie), submit formularza (gtag form_submit 56–78 ms ×4
           w labie) i offsetParent po zmianach stylu (wymuszony układ). RUM Chrome: pasek ATC p75 436 ms, 4 odsłony 1684 ms. */
        if (document.hidden || typeof requestAnimationFrame !== 'function') { runStickyAtc(clickedButton); return; }
        requestAnimationFrame(function () { setTimeout(function () { runStickyAtc(clickedButton); }, 0); });
    }

    function runStickyAtc(clickedButton) {
        var currentAtcButton = findCurrentAtcButton();

        if (currentAtcButton) {
            var cartUpdateComplete = false;
            var fallbackTimerId = null;
            var pubSubUnsubs = [];

            function finishStickyAtcLoading() {
                if (cartUpdateComplete) return;
                cartUpdateComplete = true;
                if (fallbackTimerId !== null) {
                    clearTimeout(fallbackTimerId);
                    fallbackTimerId = null;
                }
                hideStickyButtonLoading(clickedButton);
                document.removeEventListener('cart:updated', domCartListener);
                document.removeEventListener('cart:error', domCartListener);
                pubSubUnsubs.forEach(function (unsub) {
                    if (typeof unsub === 'function') unsub();
                });
                pubSubUnsubs.length = 0;
            }

            function domCartListener() {
                finishStickyAtcLoading();
            }

            if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                pubSubUnsubs.push(
                    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
                        finishStickyAtcLoading();
                    })
                );
                pubSubUnsubs.push(
                    subscribe(PUB_SUB_EVENTS.cartError, function () {
                        finishStickyAtcLoading();
                    })
                );
            }

            document.addEventListener('cart:updated', domCartListener);
            document.addEventListener('cart:error', domCartListener);

            fallbackTimerId = setTimeout(function () {
                finishStickyAtcLoading();
            }, 5000);

            currentAtcButton.click();
        } else {
            hideStickyButtonLoading(clickedButton);
        }
    }

    document.addEventListener('click', function(e) {
        var trigger = e.target && e.target.closest ? e.target.closest('.sticky-atc-trigger') : null;
        if (!trigger || !atcElement.contains(trigger)) return;
        handleStickyAtcClick(e, trigger);
    });

    if (document.querySelector('.bs-form-check-input')) {
        var originalStickyAtcPrice = null;

        function updateStickyAtcPrice() {
            var checkedInput = document.querySelector('.bs-form-check-input:checked');
            var stickyAtcPriceElements = document.querySelectorAll('.sticky-atc-price');

            if (checkedInput && stickyAtcPriceElements.length > 0) {
                var quantityBreakBlock = checkedInput.closest('.lumin-product-block-qty-break');
                var quantityBreakTotal = null;

                if (quantityBreakBlock) {
                    quantityBreakTotal = quantityBreakBlock.querySelector('[class*="lumin-product-block-qty-break-total"]');
                }

                if (!quantityBreakTotal) {
                    quantityBreakTotal = document.querySelector('[class*="lumin-product-block-qty-break-total"]');
                }

                if (quantityBreakTotal) {
                    var newPriceHTML = quantityBreakTotal.innerHTML;

                    if (newPriceHTML && newPriceHTML.trim()) {
                        if (!originalStickyAtcPrice) {
                            originalStickyAtcPrice = {};
                            stickyAtcPriceElements.forEach(function(element, index) {
                                originalStickyAtcPrice[index] = element.innerHTML;
                            });
                        }

                        stickyAtcPriceElements.forEach(function(stickyAtcPrice) {
                            var priceContainer = stickyAtcPrice.querySelector('.price__container') ||
                                               stickyAtcPrice.querySelector('[id^="price-"]') ||
                                               stickyAtcPrice.querySelector('.price');

                            if (priceContainer) {
                                priceContainer.innerHTML = newPriceHTML.trim();
                            } else {
                                stickyAtcPrice.innerHTML = newPriceHTML.trim();
                            }
                        });
                    }
                }
            }
        }

        function restoreStickyAtcPrice() {
            if (originalStickyAtcPrice) {
                var stickyAtcPriceElements = document.querySelectorAll('.sticky-atc-price');
                stickyAtcPriceElements.forEach(function(element, index) {
                    if (originalStickyAtcPrice[index]) {
                        element.innerHTML = originalStickyAtcPrice[index];
                    }
                });
            }
        }

        function handleQuantityBreakChange(event) {
            if (event.target.checked) {
                setTimeout(updateStickyAtcPrice, 100);
            } else {
                restoreStickyAtcPrice();
            }
        }

        document.querySelectorAll('.bs-form-check-input').forEach(function(input) {
            input.addEventListener('change', handleQuantityBreakChange);
        });

        function checkPreSelectedQuantityBreaks() {
            if (document.querySelector('.bs-form-check-input:checked')) {
                setTimeout(updateStickyAtcPrice, 500);
            }
        }

        checkPreSelectedQuantityBreaks();
        setTimeout(checkPreSelectedQuantityBreaks, 2000);

        var quantityBreakObserver = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach(function(node) {
                        if (node.nodeType === 1) {
                            if (node.classList && node.classList.contains('bs-form-check-input')) {
                                node.addEventListener('change', handleQuantityBreakChange);
                            }
                            var newInputs = node.querySelectorAll && node.querySelectorAll('.bs-form-check-input');
                            if (newInputs && newInputs.length > 0) {
                                newInputs.forEach(function(input) {
                                    input.addEventListener('change', handleQuantityBreakChange);
                                });
                            }
                        }
                    });
                }
            });
        });

        quantityBreakObserver.observe(document.body, {
            childList: true,
            subtree: true
        });

        document.addEventListener('click', function(event) {
            if (event.target.classList && event.target.classList.contains('bs-form-check-input')) {
                setTimeout(function() {
                    if (event.target.checked) {
                        updateStickyAtcPrice();
                    } else {
                        restoreStickyAtcPrice();
                    }
                }, 50);
            }
        });
    }

    function updateStickyPosition() {
        var isMobile = mobileQuery.matches;
        var position = isMobile ? mobilePosition : desktopPosition;
        var isShown = atcElement.classList.contains('show');

        if (isShown) {
            atcElement.style.top = '';
            atcElement.style.bottom = '';
            atcElement.style.transform = '';
            atcElement.style.opacity = '';
            atcElement.style.visibility = '';
            return;
        }

        if (isMobile) {
            atcElement.style.top = position === 'top' ? '-200px' : 'auto';
            atcElement.style.bottom = position === 'bottom' ? '-200px' : 'auto';
            atcElement.style.transform = 'translateY(100%)';
        } else {
            atcElement.style.top = position === 'top' ? '-200px' : 'auto';
            atcElement.style.bottom = position === 'bottom' ? '-200px' : 'auto';
            atcElement.style.transform = 'translateX(-50%) translateY(100%)';
        }
    }

    var visibility = { main: true, mainAbove: false, footer: false, header: true };

    function getStickyAtcShouldShow() {
        var position = mobileQuery.matches ? mobilePosition : desktopPosition;
        var shouldShow = false;

        if (stickyAtcShowMode === 'always') {
            shouldShow = true;
        } else if (stickyAtcShowMode === 'when_not_in_view') {
            shouldShow = !visibility.main;
        } else if (stickyAtcShowMode === 'after_scroll_past') {
            shouldShow = !visibility.main && visibility.mainAbove;
        }

        if (position === 'bottom' && visibility.footer) {
            shouldShow = false;
        }

        if (position === 'top' && visibility.header) {
            shouldShow = false;
        }

        return shouldShow;
    }

    function applyStickyAtcVisibility() {
        if (getStickyAtcShouldShow()) {
            atcElement.classList.add('show');
        } else {
            atcElement.classList.remove('show');
        }
        updateStickyPosition();
    }

    updateStickyPosition();

    if (stickyAtcShowMode === 'always' || !('IntersectionObserver' in window)) {
        atcElement.classList.add('show');
        updateStickyPosition();
        return;
    }

    if (!targetElement) {
        visibility.main = false;
    }

    var visibilityObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.target === footerElement) {
                visibility.footer = entry.isIntersecting;
            } else if (entry.target === headerElement) {
                visibility.header = entry.isIntersecting;
            } else {
                visibility.main = entry.isIntersecting;
                visibility.mainAbove = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
            }
        });
        applyStickyAtcVisibility();
    }, { root: null, rootMargin: '0px', threshold: 0 });

    if (targetElement) visibilityObserver.observe(targetElement);
    if (footerElement) visibilityObserver.observe(footerElement);
    if (headerElement && headerElement !== targetElement && headerElement !== footerElement) {
        visibilityObserver.observe(headerElement);
    }

    if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener('change', applyStickyAtcVisibility);
    }

    applyStickyAtcVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtc);
  } else {
    initStickyAtc();
  }
})();
